var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ds-page-home",
      class: ["style-" + _vm.headerStyle, { ceiling: _vm.isCeiling }],
      style: { "min-width": _vm.minWidth },
    },
    [
      _vm.showLicenseLayer
        ? _c(
            "div",
            { staticClass: "ds-page-home-header_license" },
            [
              _c("i", { staticClass: "iconfont icon-icon-mine-bbh ds-font3" }),
              _c("span", [
                _vm._v(
                  "许可证" +
                    _vm._s(_vm.licenseExpireWarnKey) +
                    "天后将过期，请联系供应商进行许可更新！"
                ),
              ]),
              _c(
                "DsfButton",
                {
                  attrs: { size: "small", type: "plain" },
                  on: {
                    click: function ($event) {
                      return _vm.closeLicenseLayer(true)
                    },
                  },
                },
                [_vm._v("不再提醒")]
              ),
              _c(
                "DsfButton",
                {
                  attrs: { size: "small", type: "plain" },
                  on: {
                    click: function ($event) {
                      return _vm.closeLicenseLayer(false)
                    },
                  },
                },
                [_vm._v("知道了")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.hasHeader
        ? _c(
            "div",
            {
              staticClass: "ds-page-home-header",
              style: { height: _vm.position.top },
            },
            [
              _c(
                "div",
                {
                  key: "header",
                  staticClass: "ds-page-home-header-content",
                  style: { height: _vm.position.top },
                },
                [_vm._t("header")],
                2
              ),
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "ds-page-home-body" }, [
        _vm.hasLeft
          ? _c(
              "div",
              {
                key: "left",
                staticClass: "ds-page-home-left",
                style: { width: _vm.position.left },
              },
              [_vm._t("left")],
              2
            )
          : _vm._e(),
        _c("div", { staticClass: "ds-page-home-main" }, [
          _vm.hasBreadcrumb
            ? _c(
                "div",
                {
                  key: "breadcrumb",
                  staticClass: "ds-page-home-breadcrumb",
                  style: { height: _vm.position.breadcrumb },
                },
                [_vm._t("breadcrumb")],
                2
              )
            : _vm._e(),
          _vm.viewLoaded
            ? _c(
                "div",
                { key: "default", staticClass: "ds-page-home-view" },
                [_vm._t("default")],
                2
              )
            : _vm._e(),
        ]),
        _vm.hasRight
          ? _c(
              "div",
              {
                key: "right",
                staticClass: "ds-page-home-right",
                style: { width: _vm.position.right },
              },
              [_vm._t("right")],
              2
            )
          : _vm._e(),
      ]),
      _vm.hasFooter
        ? _c(
            "div",
            {
              key: "footer",
              staticClass: "ds-page-home-footer",
              style: { height: _vm.position.bottom },
            },
            [_vm._t("footer")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }